var _excluded = ["label", "mainLabel", "onCopy", "variant", "enableCopy", "dataDogPrivacy", "data-testid"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useCallback, useEffect, useRef, useState } from 'react';
import { Group } from '../../../../../containers';
import { forwardRef, useBoolean, useTestId } from '../../../../../utils';
import { useMultiStyleConfig } from '../../../../../utils/use-style-config';
import { IconButton } from '../../../../action';
import { Text, Tooltip } from '../../../../dataDisplay';
import { Box } from '../../..';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BaseVirtualCardDetails = forwardRef((_ref, ref) => {
  var {
    label,
    mainLabel,
    onCopy,
    variant,
    enableCopy = true,
    dataDogPrivacy,
    'data-testid': dataTestId = 'base-virtual-card-details'
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var styles = useMultiStyleConfig('BaseVirtualCardDetails', {
    variant,
    enableCopy
  });
  var [isCopied, setIsCopied] = useState(false);
  var [textIsHover, setTextIsHover] = useBoolean(false);
  var copyTooltipTimeoutRef = useRef(null);
  var getTestId = useTestId(dataTestId);
  var copyText = useCallback(e => {
    if (!enableCopy) return;
    void navigator.clipboard.writeText(mainLabel);
    onCopy === null || onCopy === void 0 ? void 0 : onCopy(e);
    setIsCopied(true); // Clear the previous timeout (if any)

    if (copyTooltipTimeoutRef.current) {
      clearTimeout(copyTooltipTimeoutRef.current);
    } // Set a new timeout to reset the copied state after 2 seconds


    copyTooltipTimeoutRef.current = window.setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  }, [enableCopy, mainLabel, onCopy]); // Cleanup pending timeouts when unmounting.

  useEffect(() => () => {
    if (copyTooltipTimeoutRef.current) {
      clearTimeout(copyTooltipTimeoutRef.current);
    }
  }, []);
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    "data-component": "BaseVirtualCardDetails"
  }, getTestId()), props), {}, {
    children: /*#__PURE__*/_jsxs(Group, {
      variant: "vertical",
      spacing: "xxs",
      children: [/*#__PURE__*/_jsx(Box, {
        __css: styles['label'],
        children: /*#__PURE__*/_jsx(Text, {
          textStyle: "inline",
          color: "inherit",
          shouldSupportEllipsis: true,
          children: label
        })
      }), /*#__PURE__*/_jsxs(Box, {
        __css: styles['mainLabel'],
        onMouseOver: setTextIsHover.on,
        onMouseOut: setTextIsHover.off,
        onClick: copyText,
        children: [/*#__PURE__*/_jsx(Text, _objectSpread(_objectSpread({}, getTestId('main-label')), {}, {
          shouldSupportEllipsis: true,
          "data-dd-privacy": dataDogPrivacy,
          textStyle: "inline",
          color: "inherit",
          children: mainLabel
        })), enableCopy && /*#__PURE__*/_jsx(Box, {
          __css: styles['copyButton'],
          "data-hover": textIsHover || undefined,
          children: /*#__PURE__*/_jsx(Tooltip, {
            label: isCopied ? 'Copied' : 'Copy',
            placement: "top",
            children: /*#__PURE__*/_jsx(IconButton, _objectSpread(_objectSpread({}, getTestId('copy-button')), {}, {
              onClick: copyText,
              icon: "duplicate-flip",
              "aria-label": "copy",
              size: "small",
              variant: variant === 'inverted' ? 'nakedInverted' : 'naked'
            }))
          })
        })]
      })]
    })
  }));
});
BaseVirtualCardDetails.displayName = 'BaseVirtualCardDetails';
//# sourceMappingURL=BaseVirtualCardDetails.js.map